import { type ScriptDescriptor } from '~/types/template';

export const ocConnectWidgetScript: ScriptDescriptor = {
  src: 'https://widgets.oddschecker.com/static/oc-connect-widget/index.js',
  type: 'module',
  crossOrigin: '',
};
